import styled from "styled-components";

import { TermsStyledProps as Props } from "./Terms.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { desktop, tablet, mobile } = BREAKPOINTS;

const TermsStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: ${props =>
    !props.withBottomResponsiveButtons
      ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
      : props.withBottomSearch
      ? "var(--sizes-navbar-height-mobile)"
      : "var(--sizes-navbar-height-mobile-without-search)"};
  background-color: var(--palette-black-s0-l10);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr;
  grid-template-areas:
    ".      main   ."
    "footer footer footer";

  @media (min-width: ${desktop}px) {
    padding-top: var(--sizes-navbar-height);
  }

  .Terms {
    &__header {
      grid-area: header;
    }

    &__back {
      margin: 2rem 0;
      margin-right: auto;
    }

    &__main {
      grid-area: main;
      margin-bottom: 16rem;
      padding-top: 8.8rem;

      @media screen and (min-width: ${desktop}px) {
        display: grid;
        grid-template-columns: 44rem 1fr;
        grid-template-rows: min-content max-content;
        grid-template-areas: "profile-navigation content";
      }

      @media (max-width: ${tablet}px) {
        padding-top: 4rem;
      }
    }

    &__profile-navigation {
      display: none;

      @media screen and (min-width: ${desktop}px) {
        display: flex;
        grid-area: profile-navigation;
        margin-left: 4rem;
      }
    }

    &__content {
      grid-area: content;
      flex: 1;
      padding: 0 8rem;

      @media (max-width: ${desktop}px) {
        padding: 0 4rem;
      }

      @media (max-width: ${mobile}px) {
        padding: 0;
      }

      .Clickable {
        padding-left: 0;
        padding-top: 0;
      }
    }

    &__container {
      background-color: var(--palette-black-s2-l17);
      padding: 2.4rem;
      border-radius: 1.6rem;

      svg {
        path {
          fill: var(--palette-white);
        }
      }
    }

    &__title {
      margin-bottom: 3.6rem;
      font-size: 2rem;
      line-height: 2.8rem;
      color: var(--palette-white);
      font-weight: 600;
    }

    &__labels {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 0.8rem;
      cursor: pointer;
      font-size: 1.4rem;

      &-text {
        color: var(--palette-gray-s0-l80);
        line-height: 2.2rem;
        font-weight: 400;
      }

      &:not(:last-child) {
        border-bottom: 0.1rem solid var(--palette-gray-s0-l25);
        margin-bottom: 4rem;
        padding-bottom: 2rem;
      }
    }

    &__subtitle {
      margin-top: 3.2rem;
      margin-bottom: 0.8rem;
      font-size: 2rem;
    }

    &__paragraph {
      font-size: 1.6rem;
    }

    &__footer {
      grid-area: footer;
      padding-top: 3.2rem;
    }
  }
`;

export default TermsStyled;
